import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import PixRoundedIcon from '@mui/icons-material/PixRounded';
import SectionCard from '../../components/ui/SectionCard';
import EmptyState from '../../components/ui/EmptyState';
import { PaymentStatusChip } from '../../components/ui/StatusChip';
import api from '../../api';
import { formatCurrency } from '../../utils/image';

// Lista as mensalidades/cobranças online do usuário logado com atalho para pagar via PIX.
const MyPayments = ({ sx }) => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .get('pagamentos/me')
      .then((response) => setPayments(response.data.payments || []))
      .catch(() => setPayments([]))
      .finally(() => setLoaded(true));
  }, []);

  const pendentes = payments.filter((p) => p.status === 'pending');

  return (
    <SectionCard
      sx={sx}
      title="Minhas mensalidades"
      subtitle={pendentes.length > 0 ? `${pendentes.length} pendente(s) · ${formatCurrency(pendentes.reduce((t, p) => t + p.amount, 0))}` : 'Tudo em dia'}
      icon={<ReceiptLongRoundedIcon color="primary" />}
    >
      {loaded && payments.length === 0 ? (
        <EmptyState title="Nenhuma cobrança online" description="Quando a diretoria gerar as mensalidades, elas aparecem aqui." />
      ) : (
        <Stack divider={<Box sx={{ borderTop: 1, borderColor: 'divider' }} />}>
          {payments.map((payment) => (
            <Stack key={payment._id} direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ sm: 'center' }} sx={{ py: 1.5 }}>
              <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <Typography fontWeight={600} noWrap>{payment.description}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {formatCurrency(payment.amount)}
                  {payment.paidAt ? ` · pago em ${new Date(payment.paidAt).toLocaleDateString('pt-BR')}` : ''}
                </Typography>
              </Box>
              <PaymentStatusChip status={payment.status} />
              {payment.status === 'pending' && (
                <Button variant="contained" size="small" startIcon={<PixRoundedIcon />} onClick={() => navigate(`/pagamento/${payment.token}`)}>
                  Pagar com PIX
                </Button>
              )}
            </Stack>
          ))}
        </Stack>
      )}
    </SectionCard>
  );
};

export default MyPayments;
